/**
 * util token module
 * @module util/token
 * @example
 * import WSLib from '@tencent/weishi-lib';
 * WSLib.wsUtil.token.getToken();
 */
import cookie from './cookie';
import localstorage from './localstorage';

/**
 * get token by skey
 */
export function getToken() {
  const skey = cookie.get('skey') || '';
  let hash = 5381;
  const tempToken = localstorage.get('ws_token_tmpToken');
  const tempSkey = localstorage.get('ws_token_tempSkey');
  let token = tempToken;

  if (skey) {
    // 只有缓存中的skey失效时才重新生成gtoken
    if (skey !== tempSkey) {
      localstorage.set('ws_token_tempSkey', skey);
      let i = 0;
      const l = skey.length;
      for (; i < l; i += 1) {
        hash += (hash << 5) + skey.charAt(i).charCodeAt();
      }
      const tmpToken = hash & 0x7fffffff;
      localstorage.set('ws_token_tmpToken', tmpToken);
      token = tmpToken;
    }
  } else {
    // 不存在skey时,不需要token
    // 不需要token的时候传空的就好了, null兼容性有问题
    localstorage.set('ws_token_tmpToken', '');
    token = '';
  }

  return token;
}

/**
 * get token by skey
 */
export function getPskeyToken() {
  const skey = cookie.get('p_skey')
    || cookie.get('skey')
    || cookie.get('rv2')
    || cookie.get('access_token')
    || '';
  let hash = 5381;
  const tempToken = localstorage.get('ws_token_tmpToken');
  const tempSkey = localstorage.get('ws_token_tempSkey');
  let token = tempToken;

  if (skey) {
    // 只有缓存中的skey失效或localstorage中的token为空时才重新生成gtoken
    if (skey !== tempSkey || !token) {
      localstorage.set('ws_token_tempSkey', skey);
      let i = 0;
      const l = skey.length;
      for (; i < l; i += 1) {
        hash += (hash << 5) + skey.charAt(i).charCodeAt();
      }
      const tmpToken = hash & 0x7fffffff;
      localstorage.set('ws_token_tmpToken', tmpToken);
      token = tmpToken;
    }
  } else {
    // 不存在skey时,不需要token
    // 不需要token的时候传空的就好了, null兼容性有问题
    localstorage.set('ws_token_tmpToken', '');
    localstorage.set('ws_token_tempSkey', '');
    token = '';
  }

  return token;
}

export default {
  getToken,
  getPskeyToken,
};
